import {ENTITY_ASSIGNMENT_ORDER} from "Services/assignment/constants";

export default function orderAssignmentsByEntityType(assignments){
  return assignments.sort((a,b) =>
    ENTITY_ASSIGNMENT_ORDER.indexOf(a.entityType) - ENTITY_ASSIGNMENT_ORDER.indexOf(b.entityType));
}